import React from 'react';
import ReactDOM from 'react-dom/client';
//
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import 'rc-slider/assets/index.css';
// STYLE
import './styles/index.scss';
import './index.css';
import './fonts/line-awesome-1.3.0/css/line-awesome.css';

//
import App from './App';
import reportWebVitals from './reportWebVitals';
import { UserProvider } from 'providers/UserProvider';
import { useCookie } from 'react-use';
import { incrimentReferal } from 'utils/updateReferal';

const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement
);
if (window.location.search.includes('ref=')) {
	incrimentReferal(window.location.search.split('ref=')[1].split('&')[0]);
}

root.render(
	<React.StrictMode>
		<UserProvider>
			<App />
		</UserProvider>
	</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
